import React from 'react';
import { useTranslations } from '../../hooks/useTranslations';

function Copyright() {
    const { translations } = useTranslations();
    const date = new Date();
    const currentYear = date.getFullYear();
    return (
        <div className="copy">{`© ${currentYear} ${translations.copyright_text}`}</div>
    );
}

export default Copyright;



